exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner-button[data-v-605a4474]{margin:40px auto;background-color:transparent;max-width:1110px;border-radius:0;-webkit-box-shadow:none;box-shadow:none;border:none}.banner-button .q-card-container[data-v-605a4474],.banner-button .q-item-division[data-v-605a4474],.banner-button .q-item-link[data-v-605a4474],.banner-button .q-item[data-v-605a4474]{padding:0}.banner-button img[data-v-605a4474]{max-height:100px;width:100%;height:auto}@media (max-width:1200px){.banner-button[data-v-605a4474]{max-width:930px}}@media (max-width:992px){.banner-button[data-v-605a4474]{height:100px;padding:0 15px}.banner-button img[data-v-605a4474]{height:100px;width:100%;-o-object-fit:cover;object-fit:cover}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-605a4474","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/front/BannerButton.vue
// module id = 317u
// module chunks = 75